import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Rating } from './submodels/rating.model';
import { Statistic } from './submodels/statistic.model';

export const REVIEW_SUMMARY_SCHEMA = Object.freeze({
  RATINGS: Rating,
  STATISTICS: Statistic,
});
export const RECORD = generateSchema(REVIEW_SUMMARY_SCHEMA);
export const KEYS: any = generateKeys(REVIEW_SUMMARY_SCHEMA);

export class ReviewSummary extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.RATINGS,
        value: props.get(KEYS.RATINGS) ? new Rating(this.ratings) : null,
      },
      {
        key: KEYS.STATISTICS,
        value: props.get(KEYS.STATISTICS)
          ? new Statistic(this.statistics)
          : null,
      },
    ]);

    return selfModel as ReviewSummary;
  }

  get ratings(): Rating {
    return this.get(KEYS.RATINGS);
  }

  get statistics(): Statistic {
    return this.get(KEYS.STATISTICS);
  }
}
